import React from 'react';
import { useTranslation } from 'react-i18next';

import ErrorIcon from '@/assets/images/icons/error.svg';

import ErrorPage from '../ErrorPage';

const NotFoundError = () => {
  const { t } = useTranslation();
  return (
    <ErrorPage
      logo={<ErrorIcon />}
      title={t('components.NotFoundError.title')}
      linkHref="/admin/moderation"
      linkText={t('components.NotFoundError.linkText')}
    >
      {t('components.NotFoundError.textRequest')}
    </ErrorPage>
  );
};

export default NotFoundError;
